export const typesRedux = {
    SHOW_NAVBAR: 'SHOW_NAVBAR',

    //Auth
    AUTH_LOGIN: '[Auth Login] Load user login data',
    LOGOUT_LOGIN: '[Logout Login] Delete loaded user session data',
    VALIDATION_TOKEN:
        '[Validation Token] Validate the user active session token',

    //General
    MODE_THEME: '[Mode Theme] Load app theme mode',
    USER_LOG: '[User Log] Load all information of the logged in user to redux',

    //Stepper
    nextStepper: '[Next Stepper] Carga el siguiente formulario del stepper',
    backStepper: '[Back Stepper] Carga el anterior formulario del stepper',
    resetStepper: '[Reset Stepper] Carga el formulario inicial del del stepper',
    uploadIpOrigin: '[Upload Ip Origin] Cargar la ip del cliente al redux',
};
